import { createContext } from "react";
import { useState } from "react";

export const UserContext = createContext();

export const UserContextProvider = ({children}) => {

    const [user, setUser] = useState(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        return user || {isLogged: false, data: null};
    });

    const setSession = (userData) => {
        const user = {isLogged: true, data: userData};
        localStorage.setItem('user', JSON.stringify(user));
        setUser(user);
    }

    const destroySession = () => {
        localStorage.removeItem('user');
        setUser({isLogged: false, data: null});
    }

    return (
        <UserContext.Provider value={{user, setUser, setSession, destroySession}}>{children}</UserContext.Provider>
    )
}